// extracted by mini-css-extract-plugin
export var bodyRow = "_fc-d";
export var cardColumns = "_fc-e";
export var ellipsesOverflow = "_fc-2";
export var flatBottomCorners = "_fc-3";
export var flatTopCorners = "_fc-4";
export var headerActionsDropdown = "_fc-f";
export var headerBottomRow = "_fc-c";
export var headerTopRow = "_fc-b";
export var orderDetailsWrapper = "_fc-0";
export var orderInfoContainer = "_fc-1";
export var productDetails = "_fc-9";
export var productImage = "_fc-5";
export var responsiveTable = "_fc-8";
export var shipmentContainer = "_fc-a";
export var tableBottomLeft = "_fc-6";
export var tableBottomRight = "_fc-7";
export var trackingLink = "_fc-g";